export const TEAM_SPORTS: string[] = [
  "kegball",
  "Impostor Shots",
  "relay race",
];

export const INDIVIDUAL_SPORTS: string[] = ["dodgeball", "fingers"];

export const SPORTS: string[] = [...TEAM_SPORTS, ...INDIVIDUAL_SPORTS];
